import {makeStyles} from 'tss-react/mui'

import {RADIO_BUTTON_COLORS, RADIO_BUTTON_LAYOUT} from './RadioButton.constants'
import {RadioButtonStylingProps} from './RadioButton.types'

export const useRadioButtonStyles = makeStyles<RadioButtonStylingProps>()((
  _theme,
  {selected, disabled, variant}
) => {
  const colors = RADIO_BUTTON_COLORS[variant]

  return {
    container: {
      flex: 1,
      padding: RADIO_BUTTON_LAYOUT.container.padding,
      border: `${RADIO_BUTTON_LAYOUT.container.borderWidth} solid ${
        selected ? colors.border.selected : colors.border.default
      }`,
      borderRadius: RADIO_BUTTON_LAYOUT.container.borderRadius,
      backgroundColor: selected ? colors.background.selected : colors.background.default,
      cursor: disabled ? 'not-allowed' : 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: RADIO_BUTTON_LAYOUT.gap.internal,
      opacity: disabled ? 0.5 : 1,
      transition: 'all 0.2s ease',
      '&:hover': {
        opacity: disabled ? 0.5 : 0.9
      }
    },
    indicator: {
      width: RADIO_BUTTON_LAYOUT.indicator.size,
      height: RADIO_BUTTON_LAYOUT.indicator.size,
      borderRadius: '50%',
      border: `1px solid ${selected ? colors.indicator.selected : colors.indicator.default}`,
      backgroundColor: selected ? colors.indicator.selected : colors.background.default,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    },
    innerDot: {
      width: RADIO_BUTTON_LAYOUT.indicator.innerSize,
      height: RADIO_BUTTON_LAYOUT.indicator.innerSize,
      borderRadius: '50%',
      backgroundColor: colors.innerDot
    },
    label: {
      fontFamily: RADIO_BUTTON_LAYOUT.text.fontFamily,
      fontWeight: RADIO_BUTTON_LAYOUT.text.fontWeight,
      fontSize: RADIO_BUTTON_LAYOUT.text.fontSize,
      lineHeight: RADIO_BUTTON_LAYOUT.text.lineHeight,
      color: RADIO_BUTTON_LAYOUT.text.color,
      userSelect: 'none'
    }
  }
})

export const useRadioButtonGroupStyles = makeStyles<{disabled: boolean}>()(
  (_theme, {disabled}) => ({
    container: {
      opacity: disabled ? 0.5 : 1
    }
  })
)
